<template lang="pug">
    .contactpersons.container.mx-auto
        .contact-wrap
          Panel(
            v-for="( panel, i ) in accordion"
            :key="panel.id"
            :index="i"
            :panel="panel"
        )
</template>

<script>
//import AOS from 'aos';
import { get, cloneDeep } from '@/helpers';
import Panel from './Panel';

export default {
    name: 'ContactPerson',
    props: {
        section: {
            type: Object,
            required: true
        }
    },
    components: {
        Panel
    },
    computed: {
        accordion() {
            let accordion = this.section.contents || [];
            return cloneDeep(accordion).sort((a, b) => get(a, 'position', 0) - get(b, 'position', 0));
        }
    }
};
</script>

<style lang="sass" scoped>
@import "~@/assets/sass/variables"

.contactpersons
  .contact-wrap
    @apply grid grid-cols-1 gap-0 font-light
    font-family: $font-alternative
    color: $cc-font-base
    @screen xs
      @apply grid grid-cols-2 gap-8
    @screen sm
      @apply grid grid-cols-3 gap-8
    @screen lg
      @apply grid-cols-4 gap-12
    @screen 2xl
      @apply grid-cols-5
</style>
